import { render, staticRenderFns } from "./ed-language.vue?vue&type=template&id=11be8cbb&"
import script from "./ed-language.ts?vue&type=script&lang=js&"
export * from "./ed-language.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports